import { useContext, useEffect, useState } from "react";
import LangContext from "./LangContext";
import { Container, InfoCard, InfoGroup, SimpleElementRenderer } from "./Basic";
import "./ProfessorDetail.sass";
import LangContext from "./LangContext";

function ProfessorDetailTab({ tabNames, currentTab, onTabClick }) {
    return (
        <div
            active=""
            className="access-professor-detail-tab"
        >
            {tabNames.map((tabName, idx) => (
                <span
                    key={idx}
                    active={idx == currentTab ? '' : null}
                    onClick={() => onTabClick(idx)}
                >
                    {tabName}
                </span>
            ))}
        </div>
    );
}

function ProfessorCurrentResearch({ background }) {
    const lang = useContext(LangContext);
    const [content, setContent] = useState(null);
    const active = content != null;

    useEffect(() => {
        if (process.env.NODE_ENV !== "production")
            setTimeout(() =>
                setContent(
                    [
                        {
                            "type": "image",
                            "config": {
                                "srcs": "http://140.112.20.133:8081/images/current_research.png",
                                "width": "80%"
                            }
                        },
                        {
                            "type": "text",
                            "config": {
                                "content": "The laboratory is currently focused on three core projects for research direction, with each group led by 2 to 4 senior doctoral students and several masters. Students interested in the laboratory can refer to the ICS group's recruitment presentation slides or the laboratory introduction video. Students who want to join are welcome to send an email to Professor Wu An-Yu ([link=mailto:andywu@ntu.edu.tw]andywu@ntu.edu.tw[n]). If you want to understand more deeply the research or culture of the laboratory, you can directly contact any doctoral student in the laboratory.",
                                "align": "justify"
                            }
                        },
                        {
                            "type": "text",
                            "config": {
                                "content": "混合式AI架構(A世代計畫): [b]林明廣[l] [link=mailto:chrislin@access.ee.ntu.edu.tw]chrislin@access.ee.ntu.edu.tw[r]\n機器學習輔助之智慧接收機設計(聯發科計畫): [b]陳祈瑋[l] [link=mailto:wilbur@access.ee.ntu.edu.tw]wilbur@access.ee.ntu.edu.tw[r]\n巨量機器異常偵測應用(科技部計畫): [b]羅翊誠[l] [link=mailto:alan@access.ee.ntu.edu.tw]alan@access.ee.ntu.edu.tw",
                                "align": "justify"
                            }
                        }
                    ]), 200);
        else
            fetch(`/api/professor_details/research_map.${lang}.json`)
                .then(res => {
                    if (res.ok) return res.json();
                    throw new Error(`Fetch /api/professor_details/research_map.${lang}.json failed`);
                })
                .then(json => setContent(json))
                .catch(e => console.error(e));
    }, [lang]);

    return (
        <SimpleElementRenderer
            active={active}
            fill={background}
            full={true}
            padding="all"
            contents={content}
        />
    );
}

function ProfessorBiography({ background }) {
    const lang = useContext(LangContext);
    const [content, setContent] = useState(null);
    const active = content != null;

    useEffect(() => {
        if (process.env.NODE_ENV !== "production")
            setTimeout(() => setContent(
                [
                    {
                        type: "text",
                        content: "[b]An-Yeu (Andy) Wu[r] received the B.S. degree from National Taiwan University in 1987, and the M.S. and Ph.D. degrees from the University of Maryland, College Park in 1992 and 1995, respectively, all in Electrical Engineering.\n\nFrom August 1995 to July 1996, he was a Member of Technical Staff (MTS) at AT&T Bell Laboratories, Murray Hill, NJ, working on high-speed transmission IC designs. From 1996 to July 2000, he was with the Electrical Engineering Department of National Central University, Taiwan. In August 2000, he joined the faculty of the Department of Electrical Engineering and the Graduate Institute of Electronics Engineering, National Taiwan University (NTU), where he is currently a Distinguished Professor. His research interests include low-power/high-performance VLSI architectures for DSP and communication applications, bio-medical signal processing, reconfigurable broadband access systems and architectures, and System-on-Chip (SoC)/AI/ML platform for software/hardware co-design. He has published more than 400 refereed journal and conference papers in above research areas, together with five book chapters and 25 granted US patents.\n\nDr. Wu had served as Associate Editor in several leading IEEE journals in circuits and signal processing areas, such as IEEE Transactions on Signal Processing, IEEE Transactions on Circuits and Systems—PART I, IEEE Transactions on Circuits and Systems—PART II, and IEEE Transactions on Very Large Scale Integration (VLSI) Systems. He acted as the Lead Guest Editor of the special issue of “2010 IEEE Workshop on Signal Processing Systems (SiPS) in JSPS (2011), and the special issue of “Signal Processing for Broadband Access Systems: Techniques and Implementations,” in EURASIP Journal on Applied Signal Processing (2003). He also acted as the Guest Editor of a special issue of “Low-Power, Reliable, and Secure Solutions for Realization of Internet of Things,” in IEEE Journal on Emerging and Selected Topics in Circuits and Systems (2013). Prof. Wu served as the General Co-Chair of 2013 International Symposium on VLSI Design, Automation& Test (VLSI-DAT), and 2013 IEEE Workshop on Signal Processing Systems (SiPS). He also served as Technical Program Co-Chair of 2014 International SoC Design Conference (ISOCC) and 2014 IEEE Asia Pacific Conference on Circuits and Systems (APCCAS). From 2012 to 2014, he served as the Chair of VLSI Systems and Applications (VSA) Technical Committee (TC), one of the largest TCs in IEEE Circuits and Systems (CAS) Society.\n\nFrom August 2007 to Dec. 2009, he was on leave from NTU and served as the Deputy General Director of SoC Technology Center (STC), Industrial Technology Research Institute (ITRI), Hsinchu, TAIWAN, supervising WiMAX, Parallel Core Architecture (PAC) VLIW DSP Processor, and Android-based Multicore SoC platform projects. From 2012 to 2013. From March 2014 to September 2017, Dr. Wu is in charge of the overall talent cultivation program office in National Program for Intelligent Electronics (NPIE), under sponsorship of Ministry of Education in Taiwan.\n\nIn 2015, Prof. Wu was elevated to IEEE Fellow for his contributions to “DSP algorithms and VLSI designs for communication IC/SoC.” From August 2016 to July 2019, he served as the Director of Graduate Institute of Electronics Engineering (GIEE), National Taiwan University. He was elected as a Board of Governor (BoG) Member in IEEE Circuits and Systems Society (CASS) for two terms (2016-2018, 2019-2021). From 2020 to 2021, he served as the Editor-in-Chief (EiC) of IEEE Journal on Emerging and Selected Topics in Circuits and Systems (JETCAS), one of the flagship journals owned by IEEE Circuits and Systems Society (CASS). He received 2019 ECE Distinguished Alumni Award from the ECE department of University of Maryland (UMD), and 2019 Outstanding Engineering Professor Award, from the Chinese Institute of Engineers (CIE), Taiwan.",
                        align: "justify"
                    }
                ]
            ), 200);
        else
            fetch(`/api/professor_details/biography.${lang}.json`)
                .then(res => {
                    if (res.ok) return res.json();
                    throw new Error(`Fetch /api/professor_details/biography.${lang}.json failed`);
                })
                .then(json => setContent(json))
                .catch(e => console.error(e));
    }, [lang]);

    return (
        <SimpleElementRenderer
            active={active}
            fill={background}
            full={true}
            padding="all"
            contents={content}
        />
    );
}

function ProfessorHonors({ background }) {
    const lang = useContext(LangContext);
    const [content, setContent] = useState(null);
    const active = content != null;

    useEffect(() => {
        if (process.env.NODE_ENV !== "production")
            setTimeout(() => setContent(
                [
                    {
                        "title": "2020 Y. Z. Hsu Technology Invention Award",
                        "description": "by Far Eastern Y.Z. Hsu Science and Technology Memorial Foundation"
                    },
                    {
                        "title": "2020 Y. Z. Hsu Scientific Paper Award",
                        "description": "by Far Eastern Y.Z. Hsu Science and Technology Memorial Foundation"
                    },
                    {
                        "title": "2019 UMD ECE Distinguished Alumni Award",
                        "description": "established since 2012, awarded to distinguished alumni in ECE department of University of Maryland (UMD)"
                    }
                ]
            ), 200);
        else
            fetch(`/api/professor_details/honors.${lang}.json`)
                .then(res => {
                    if (res.ok) return res.json();
                    throw new Error(`Fetch /api/professor_details/honors.${lang}.json failed`);
                })
                .then(json => setContent(json))
                .catch(e => console.error(e));
    }, [lang]);

    return (
        <Container
            active={active}
            fill={background}
            full={true}
            padding="horizontal"
        >
            {content?.map((honor, idx) => (
                <InfoCard
                    key={idx}
                    active={true}
                    title={honor.title}
                    description={honor.description}
                    descriptionColor="light"
                    descriptionAlign="center"
                />
            ))}
        </Container>
    );
}

function ProfessorPublication({ background }) {
    const lang = useContext(LangContext);
    const [content, setContent] = useState(null);
    const active = content != null;

    useEffect(() => {
        if (process.env.NODE_ENV !== "production")
            setTimeout(() => setContent(
                [
                    {
                        "title": "2023 - Journal",
                        "contents": [
                            {
                                "title": "[b]Win-Ken Beh, Yi-Hsuan Wu and An-Yeu (Andy) Wu[r], [i]“Robust PPG-based Mental Workload Assessment System using Wearable Devices,” in IEEE Journal of Biomedical and Health Informatics (JBHI), vol. 27, no. 5, pp. 2323-2333, May 2023.[ppt=http://www.google.com]",
                                "url": "/files/(2022)A_2.47_J_sample_QR-Decomposition-based_Extreme_Learning_Machine_Engine_Supporting_Online_Class_Incremental_Learning_for_ECG-based_User_Identification.pdf"
                            },
                            {
                                "title": "[b]Yu-Shan Tai, Cheng-Yang Chang, Chieh-Fang Teng, Yi-Ta Chen, and An-Yeu Wu[r], [i]“Joint Optimization of Dimension Reduction and Mixed-Precision Quantization for Activation Compression of Neural Networks” accepted for publication in in IEEE Trans. Computer-Aided Design of Integrated Circuits and Systems (TCAD), March 2023 (Early access)."
                            },
                            {
                                "title": "[b]Win-Ken Beh, Yi-Hsuan Wu and An-Yeu (Andy) Wu[r], [i]“Robust PPG-based Mental Workload Assessment System using Wearable Devices,” in IEEE Journal of Biomedical and Health Informatics (JBHI), vol. 27, no. 5, pp. 2323-2333, May 2023.",
                                "url": "/files/(2022)A_2.47_J_sample_QR-Decomposition-based_Extreme_Learning_Machine_Engine_Supporting_Online_Class_Incremental_Learning_for_ECG-based_User_Identification.pdf"
                            }
                        ]
                    },
                    {
                        "title": "2023 - Conference",
                        "contents": [
                            {
                                "title": "[b]Chi-Tse Huang, Cheng-Yang Chang, Yu-Chuan Chuang, and An-Yeu (Andy) Wu[r], [i]“BWA-NIMC: Budget-based Workload Allocation for Hybrid Near/In-Memory-Computing,” accepted in IEEE/ACM Design Automation Conf (DAC’23), July 2023."
                            }
                        ]
                    }
                ]
            ), 200);
        else
            Promise.all([
                fetch(`/api/research/journals.json`),
                fetch(`/api/research/conferences.json`)
            ])
            .then(res => {
                if (res[0].ok && res[1].ok) return Promise.all([res[0].json(), res[1].json()]);
                throw new Error(`Fetch /api/research/journals.json, /api/research/conferences.json failed`);
            })
            .then(([json_journal, json_conference]) => {
                let latest_journal_year = Math.max(...json_journal.map(y => parseInt(y.title)));
                let latest_conference_year = Math.max(...json_conference.map(y => parseInt(y.title)));
                let journals = json_journal.find(y => parseInt(y.title) == latest_journal_year).contents;
                let conferences = json_conference.find(y => parseInt(y.title) == latest_conference_year).contents;
                return [
                    {
                        "title": `${latest_journal_year} - Journal`,
                        "contents": journals.slice(0, 5)
                    },
                    {
                        "title": `${latest_conference_year} - Conference`,
                        "contents": conferences.slice(0, 5)
                    }
                ]
            })
            .then(json => setContent(json))
            .catch(e => console.error(e));
    }, [lang]);

    return (
        <Container
            active={active}
            fill={background}
            full={true}
            padding="all"
        >
            {content?.map((group, idx) => (
                <InfoGroup
                    key={idx}
                    active={true}
                    title={group.title}
                    contents={group.contents.map(publication => ({
                        title: "",
                        description: publication.title + (publication.url != null ? `[pdf=${publication.url}]` : "")
                    }))}
                    descriptionAlign="left"
                />
            ))}
        </Container>
    );
}

function ProfessorService({ background }) {
    const lang = useContext(LangContext);
    const [content, setContent] = useState(null);
    const active = content != null;

    useEffect(() => {
        if (process.env.NODE_ENV !== "production")
            setTimeout(() => setContent(
                [
                    {
                        "category": "Experience",
                        "content": [
                            {
                                "title": "Distinguished Professor",
                                "description": "Graduate Institute of Electronics Engineering, and Electrical Engineering Department\nNational Taiwan University (NTU)\nAug. 2015 – Now"
                            },
                            {
                                "title": "Director",
                                "description": "MediaTek-NTU Research Center, National Taiwan University (NTU)\nJan. 2022 – Now"
                            },
                            {
                                "title": "Director",
                                "description": "Graduate Institute of Electronics Engineering (GIEE), National Taiwan University (NTU)\nAug. 2016 – July 2019"
                            }
                        ]
                    },
                    {
                        "category": "Technical Committee",
                        "content": [
                            {
                                "title": "",
                                "description": "TC Chair (2012-2014)and Secretary & Chair-Elect (2009-2012), VLSI Systems and Applications (VSA-TC), IEEE Circuits and Systems Society (since 2002)"
                            },
                            {
                                "title": "",
                                "description": "Design and Implementation of Signal Processing Systems (DISPS-TC), IEEE Signal Processing Society (since 2004)"
                            }
                        ]
                    }
                ]
            ), 200);
        else
            fetch(`/api/professor_details/services.${lang}.json`)
                .then(res => {
                    if (res.ok) return res.json();
                    throw new Error(`Fetch /api/professor_details/services.${lang}.json failed`);
                })
                .then(json => setContent(json))
                .catch(e => console.error(e));
    }, [lang]);

    return (
        <Container
            active={active}
            fill={background}
            full={true}
            padding="all"
        >
            {content?.map((group, idx) => (
                <InfoGroup
                    key={idx}
                    active={true}
                    title={group.title}
                    contents={group.contents.map(c => ({
                        title: c.title,
                        description: c.description,
                        align: c.title == "" ? "justify" : "center",
                        color: c.title == "" ? "dark" : "light"
                    }))}
                />
            ))}
        </Container>
    );
}

function ProfessorDetail({ config }) {
    const lang = useContext(LangContext);
    const [tab, setTab] = useState(0);
    const onTabClick = (tabId) => setTab(tabId);

    const availableTabData = {
        'current_research': ['Current Research', '研究方向'],
        'biography': ['Biography', '自傳'],
        'honors': ['Honors & Awards', '榮譽紀錄'],
        'publications': ['Recent Publications', '著作專利'],
        'services': ['Service', '經歷']
    };
    let content = config?.contents || [];
    content = content?.filter(d => Object.keys(availableTabData).includes(d));

    const tabNames = content?.map(d => lang == 'en' ? availableTabData[d][0] : availableTabData[d][1]);
    const tabIdx = content;

    return (
        <>
            <ProfessorDetailTab tabNames={tabNames} currentTab={tab} onTabClick={onTabClick} />
            {tabIdx[tab] == 'current_research' && <ProfessorCurrentResearch background={config?.background} />}
            {tabIdx[tab] == 'biography' && <ProfessorBiography background={config?.background} />}
            {tabIdx[tab] == 'honors' && <ProfessorHonors background={config?.background} />}
            {tabIdx[tab] == 'publications' && <ProfessorPublication background={config?.background} />}
            {tabIdx[tab] == 'services' && <ProfessorService background={config?.background} />}
        </>
    )
}

export {ProfessorDetail, ProfessorCurrentResearch, ProfessorBiography, ProfessorHonors, ProfessorPublication, ProfessorService};